/**
 * rest 请求配置
 */

import ajax from '../common/ajax'

const optionNoneV = {
  customUrl: '/',
  cache: false
}

const optionsV2 = {
  customUrl: '/api/v2',
  cache: false
}

const rest = {
  common: {
    /**
     * 数据埋点
     */
    getEventTrackToken: ajax.query('/event_tracking/access_token'), // 获取埋点数据上报接口access_token
    postEventTrack: (config: any) => ajax.create('/event_tracking/events', { ...config, useJsonData: true }), // 数据上报
    // 获取当前用户信息 涉及到没车场的门店点击 这里后端单独给了一个用户信息的接口
    getCurrentUserInfo: ajax.query('/car_visit/current_user_info')
  },
  // 售后管理
  aftersales: {
    // 获取与外部联系人绑定的客户信息
    getExternalUserInfo: ajax.query('/after_sale/external_user/customer'),
    // 通过手机号获取客户信息
    getUserInfoByPhoneNumber: ajax.query('/after_sale/customers/customer'),
    // 更新外部联系人绑定的客户
    updateExternalUser: ajax.putWay('/after_sale/external_user/customer', { useJsonData: true }),
    /**
     * 获取客户名下所有车辆
     * @see https://yapi.lixinio.com/project/65/interface/api/63249
     */
    getCarList: (userId: string | number) => ajax.query(`/after_sale/customers/${userId}/base_cars`),
    // 获取车辆详情
    getCarInfo: (carId: string | number) => ajax.query(`/after_sale/base_cars/base_car/${carId}`),
    // 获取车辆服务人员
    getServiceEmployee: (base_car_id: string | number) => ajax.query(`/after_sale/service_employee/${base_car_id}`),
    // 获取车辆是否在店
    getCarStatus: ajax.query('/after_sale/is_car_in_store'),
    // 获取车辆业务动态进度
    getCarBusinessDynamicsProgress: ajax.query('/after_sale/business_dynamic/progress'),
    // 获取车辆业务动态提醒
    getCarBusinessDynamicsTips: ajax.query('/after_sale/business_dynamic/notification'),
    /**
     * 添加车辆
     * @see https://yapi.lixinio.com/project/65/interface/api/97610
     */
    addBaseCar: (userId: string | number) => ajax.create(`/after_sale/customers/${userId}/base_cars`, { useJsonData: true }),
    /**
     * 获取售后服务组列表
     * @see https://yapi.lixinio.com/project/65/interface/api/97544
     */
    getServiceGroupList: ajax.query('/after_sale/external_user/teams'),
    /**
     * 外部联系人预绑定车主服务群
     * @see https://yapi.lixinio.com/project/65/interface/api/97539
     */
    preBindOwnerServiceGroup: ajax.create('/after_sale/external_user/chat/pre_bind', { useJsonData: true }),
    /**
     * 获取车主服务群客户列表
     * @see https://yapi.lixinio.com/project/65/interface/api/97549
     */
    getOwnerServiceGroupCustomerList: (chatid: string) => ajax.query(`/after_sale/external_user/groupchat/${chatid}/customers`),
    /**
     * 绑定车主服务群
     * @see https://yapi.lixinio.com/project/65/interface/api/97534
     */
    bindOwnerServiceGroup: ajax.create('/after_sale/external_user/chat/bind', { useJsonData: true }),
    /**
     * 更新客户默认车辆
     * @see https://yapi.lixinio.com/project/65/interface/api/97631
     */
    updateCustomerDefaultCar: ajax.putWay('/after_sale/external_user/customer/default_car', { useJsonData: true })
  },
  // 门店信息
  store: {
    getStoreInfo: ajax.query('/store_info')
  },
  // 今日到店车主
  cus: {
    // 获取今日到店车主列表
    getTodayVisitorList: ajax.query('/visits'),
    // 获取车辆详情
    getCarInfo: ajax.query('/cars'),
    // 当前车主可赠与的优惠券列表
    getGivenCouponsList: ajax.query('/cars'),
    // 优惠券可被赠与对象
    getGivenUserList: ajax.query('/cars'),
    // 提交预存保费方案
    commitPreQuest: ajax.create('/cars')
  },
  // 优惠券核销
  cou: {
    // 优惠券详情
    getCouponDetail: ajax.query('/coupons'),
    // 核销优惠券
    writeOffCoupon: ajax.patch('/coupons', { useJsonData: true }),
    getEmployees: ajax.query('/auctions/common/employees'), // 业务顾问选择列表
    checkList: {
      // 待审核列表
      renewalList: ajax.query('/insurance_quotes/reviews'),
      // 续保新报价单详情
      insuranceQuotes: ajax.query('/insurance_quotes')
    },
    // 审核续保报价
    checkRenewal: ajax.patch('/insurance_quotes', { useJsonData: true })
  },
  cardCheck: {
    // 获取卡券审核列表
    reviewList: ajax.query('/coupon/send_requests', optionsV2),
    // 获取待我审批的卡券审核列表
    myPendingreviewList: ajax.query('/coupon/my_pending_review_send_requests', optionsV2),
    // 获取审批单详情
    getReviewDetail: (id: number) => ajax.query(`/coupon/send_requests/${id}`, optionsV2),
    // 审批通过
    updateReviewApprove: (id: number) => ajax.create(`/coupon/send_requests/${id}/approve`, optionsV2),
    // 审批驳回
    updateReviewReject: (id: number) => ajax.create(`/coupon/send_requests/${id}/reject`, {
      ...optionsV2,
      useJsonData: true
    })
  },
  coupon: {
    // 审核通过或不通过
    check: ajax.create('/coupon', {
      useJsonData: true
    }),
    // 优惠券发放记录的放客户信息
    couponCustomerInfo: ajax.query('/coupon/customer_info'),
    // 优惠券发放记录
    getValidCouponList: ajax.query('/coupon/view_issued_coupon'),
    // 领券码列表
    getQRCodeList: ajax.query('/coupon/coupon_batch_groups'),
    // 获取二维码
    getQRCode: (id: number) => ajax.query(`/coupon/coupon_batch_group_qrcode/${id}`),
    // 核销使用项目列表
    getWriteOffProjects: ajax.query('/coupon/write_off_projects', optionsV2)
  },
  gift: { // 礼品卡
    // 使用卡号查询礼品卡
    getGiftCardByCode: ajax.query('/gift_card/query_for_write_off'),
    // 礼品卡核销
    checkoffGiftCard: ajax.create('/gift_card/write_off', { useJsonData: true }),
    // 礼品卡审核列表
    getReviewingList: ajax.query('/gift_card/card_issue_requests'),
    // 礼品卡审核
    check: ajax.patch('/gift_card/card_issue_requests', { useJsonData: true }),
    // 获取退回申请信息
    getRetreatCardById: ajax.query('/gift_card/retreat_requests'),
    // 退回申请审核
    retreatCheck: ajax.patch('/gift_card/retreat_requests', { useJsonData: true }),
    // 礼品卡发记录的放客户信息
    giftCustomerInfo: ajax.query('/gift_card/customer_info'),
    // 礼品卡发放记录
    getValidGiftList: ajax.query('/gift_card/view_issued_gift_card')
  },
  // 微信配置相关
  wx: {
    // 评价批量上传
    getReviewImages: ajax.create('/upload-image', { useJsonData: true }),
    getWeChatConfigResource: ajax.query('/platform/config/weixin'),
    getContactConfig: ajax.query('/platform/config/contact'),
    // 线索模块
    getImageByInquiry: ajax.create('/save-wx-image'),
    // 拍卖模块
    getImageByAuction: ajax.create('/save-wx-image-without-login'),
    getImageByAuctionInBatch: ajax.create('/save-wx-image-without-login', { useJsonData: true }),
    getImageBatch: ajax.create('/save-wx-image', { useJsonData: true }),
    // 离店登记上传图片
    getLeaveStoreImage: ajax.create('/save-wx-image/park_abnormal_exit_reason', { useJsonData: true })
  },
  appointment: {
    // 获取所有预约列表
    getAppointmentList: ajax.query('/service/bookings'),
    // 算法三是否可见
    getAutoSolutionRule3: ajax.query('/solicit_car/auto_solution_rule3/auth'),
    // 车牌模糊搜索
    getSolicitCarCarInfo: ajax.query('/solicit_car/car_info'),
    // 关联车辆详情
    getsolicitCarDetails: (solicitCarId: number) => ajax.query(`/solicit_car/${solicitCarId}/details`),
    // 保养日期试算
    creatSolocitCarFixedMaintainDateClac: ajax.create(`/solicit_car/fixed_maintain_date_calc`, { useJsonData: true }),
    // 同步保养日期
    creatSolocitCarFixedMaintainDateSync: ajax.create(`/solicit_car/fixed_maintain_date_sync`, { useJsonData: true }),
    // 门店配置的动力类型
    getSolocitCarPowerType: ajax.query('/solicit_car/repair_categories'),
    // 获取预约详情
    getAppointmentDetailById: ajax.query('/service/bookings'),
    // 修改预约状态
    updateAppointmentStatus: (id: string) => ajax.patch(`/service/bookings/${id}/status`),
    // 获取服务项目
    getServices: ajax.query('/service/services'),
    // 获取到店提醒基础信息
    getArrivalNotification: (ruleId: number) => ajax.query(`/arrival_notification/rules/${ruleId}`),
    // 更新到店提醒结果反馈
    updateArrivalNotification: (ruleId: number) => ajax.putWay(`/arrival_notification/rules/${ruleId}`, { useJsonData: true }),
    // 获取来源渠道
    getChannels: ajax.query('/service/channels'),
    // 获取顾问接口
    getConsultants: ajax.query('/service/service_consultants'),
    // 获取养修预约规则
    getBasicSetup: ajax.query('/service/basic_setup'),
    // 新增预约
    addAppointment: ajax.create(`/service/service_booking`, { useJsonData: true }),
    // 更改预约
    updateAppointment: (id: string) => ajax.create(`/service/service_bookings/${id}`, { useJsonData: true }),
    // 更改预约时间
    updateAppointmentTime: (id: string) => ajax.patch(`/service/service_bookings/${id}/appointed_time`),
    // 获取该店可用的时间段
    getPeriods: ajax.query('/service/service_bookings_periods'),
    // 获取该店可用的日期
    getBookingDate: ajax.query('/service/service_bookings_date'),
    // 根据车牌号或手机号查看预约记录
    getBookingRecord: ajax.query('/service/contacts', { useJsonData: true }),
    // 接待人列表
    getReceivers: ajax.query('/service/receivers'),
    // 获取每日简报日数据
    getDailyDaily: ajax.query('/dc/solicit_booking/statistic/daily'),
    // 获取每日简报月数据
    getDailyMonthly: ajax.query('/dc/solicit_booking/statistic/monthly')
  },
  // 车辆道闸
  barriergate: {
    // 获取审核列表 以及无牌
    getCheckFlowList: (name: string) => ajax.query(`/visits/exiting/process/${name}`),
    // 更新审核状态
    updateCheckState: ajax.patch('/visits/exiting/process', { useJsonData: true }),
    // 获取所有待放行车辆
    getAllFlowList: ajax.query('/visits/exiting'),
    // 获取审核流程的步骤信息
    getFlowStep: ajax.query('/visits'),
    // 获取放行备注列表
    getExitCategories: ajax.query('/car_visit/exit_categories'),
    // 上传放行备注图片
    uploadWorkflowImages: ajax.create(`/save-wx-image/park_workflow`, { useJsonData: true }),
    // 提交构建的审核流程
    createFlow: ajax.create('/visits', { useJsonData: true }),
    // 查看放行进度
    getFlowDetail: ajax.query('/visits'),
    // 车辆轨迹
    getTrajectoryDetail: ajax.query('/visits'),
    // 撤回放行申请
    callBackReleaseApply: ajax.patch('/visits'),
    // 获取客户申请放行信息
    getEntryPermitInfo: (id: string) => ajax.query(`/visits/exiting/process/requisition/${id}/start`),
    // 车辆放行驳回
    rejectEntryPermit: ajax.create('/visits/exiting/process/requisition/rebut', { useJsonData: true }),
    // 获取本店本品信息
    getSelfBrands: ajax.query('/self_brands'),
    // 查询无牌车辆放行申请
    getUnlicensedCarExiting: ajax.query('/car_visit/unlicensed_car_exit_requisitions/latest'),
    // 创建无牌车放行
    createUnlicensedCarExiting: ajax.create('/car_visit/unlicensed_car_exit_requisitions', { useJsonData: true }),
    // 获取车场出口设备列表
    getExitDevices: ajax.query('/visits/park/exit_devices'),
    // 无牌车确认放行
    createUnlicensedExit: (requisition_id:string) => ajax.create(`/car_visit/unlicensed_car_exit_requisitions/${requisition_id}/pre_exit`, { useJsonData: true }),
    // 无牌获取放行审批信息
    getUnlicensedExitInfo: ajax.query('/visits/exiting/process/unlicensed_requisition/start')
  },
  // 短信回复
  smsReply: {
    // 获取用户短信内容
    getReceiveSms: ajax.query('/get_receive_sms'),
    // 发送短信
    sendSMS: ajax.create('/send_sms')
  },
  // 车信息
  carInfo: {
    // 获取精真估品牌列表和车系列表
    getCarBrandList: ajax.query('/jzg_car_models/brands'),
    // 获取精真估车型列表
    getCarModelList: ajax.query('/jzg_car_models/series'),
    query: ajax.query(''),
    create: ajax.create('', { useJsonData: true }),
    // 保存评估
    submitEvaluate: ajax.patch('', { useJsonData: true }),
    // 提交收车信息
    recycleCar: ajax.create('/auctions/car_infos', { useJsonData: true })
  },
  // 中升二手车
  usedCar: {
    // 提交二手车信息
    submit: ajax.putWay('/used_car/tickets', { useJsonData: true }),
    // 获取二手车线索列表
    getCarList: ajax.query('/used_car/tickets'),
    // 获取二手车线索详情、图片、合同记录、操作权限
    getTicket: ajax.query('/used_car/ticket'),
    // 操作
    traceOperate: ajax.putWay('/used_car/ticket'),
    // 新增跟进 （json传参）
    addFollowup: ajax.putWay('/used_car/ticket', { useJsonData: true }),
    // 审核
    review: ajax.create('/used_car/ticket', { useJsonData: true }),
    // 预创建线索评估车辆信息
    getCarInfoId: ajax.putWay('/used_car/ticket', { useJsonData: true }),
    // 到店车辆优化GET
    optimizeCarStore: ajax.query('/used_car/car_exits'),
    // 获取发现本品数据列表
    getSharedCarList: ajax.query('/auctions/shared_cars'),
    // 获取发现本品车辆详情
    getSharedCarDetail: ajax.query('/auctions/shared_cars'),
    // 获取出库价格参考列表
    getReferenceCarList: ajax.query('/used_car/ticket'),
    // 获取出库参考车辆详情
    getReferenceCarDetail: ajax.query('/used_car/ticket/reference_cars'),
    // 更新车主信息
    updateOwner: (ticketId: string) => ajax.create(`/used_car/ticket/${ticketId}/update_owner`, { useJsonData: true }),
    // 获取收到报价邀请的车商数
    getTaggedDealers: ajax.query('/auctions/cars'),
    // ============ 查询历史车况 ==============
    getInquiryOrderInfo: ajax.query('/cbs/cbs_order'),
    postInquiryOrderInfo: ajax.create('/cbs/pay_cbs_order', { useJsonData: true }),
    // 查看查询结果入口
    getConditionReport: ajax.query('/cbs/get_cbs_report')
  },
  // 询价
  inquiry: {
    // 查看线索询价列表
    getCarList: ajax.query(''),
    // 查看线索询价详情
    getEnquiryInfo: ajax.query(''),
    // 查看车商列表及详情
    getDealerUsers: ajax.query('/used_car/dealer_users'),
    // 查看车商列表及详情
    getDealerUsersDetail: ajax.query('/used_car/dealer/user'),
    // 提交线索询价
    submitEnquiry: ajax.putWay('', { useJsonData: true }),
    // 获取车辆询价列表（包括车辆询价和线索询价）
    getCarClueEnquiry: ajax.query('/auctions/auction_cars')
  },
  // 拍卖二手车
  auction: {
    // 编辑车辆||下架拍卖
    deleteCarById: ajax.delete('/auctions'),
    // 车辆管理列表
    getVehicleList: ajax.query('/auctions/auction_cars'),
    // 车辆管理 => 车辆详情
    getVehicleCarDetail: ajax.query('/auctions/auction_cars'),
    // 订单详情
    getOrderDetail: ajax.query('/auctions/auction_order'),
    // 车辆详情
    getStatusDetail: ajax.query('/auctions/car_infos'),
    // 车辆竞拍人管理列表
    getBiddersList: ajax.query('/auctions/bidders'),
    // 车辆竞拍人详情
    getBidderDetail: ajax.query('/auctions/bidders'),
    // 新增竞拍人
    addBidder: ajax.create('/auctions/bidders/add'),
    // 拍卖管理列表
    getAuctionList: ajax.query('/auctions/'),
    // 删除草稿
    // deleteDraftById: ajax.delete('/auctions'),
    // 新增生成ID
    getNewId: ajax.create('/auctions/new'),
    // 新增&&编辑二手车拍卖、评估
    evaluate: ajax.query(''),
    // 保存评估
    submitEvaluate: ajax.patch('', { useJsonData: true }),
    // 新增车辆
    getNewCar: ajax.create('/auctions/new_car_info', { useJsonData: true }),
    // 新增&&编辑二手车拍卖
    saveOrEditUsedCarBarrier: ajax.query('/auctions'),
    // 获取车辆图片
    getImages: ajax.query('/auctions'),
    // 关闭交易
    orderClose: ajax.create('/auctions/auction_order_close', { useJsonData: true }),
    // 已收款
    savePaid: ajax.create('/auctions/auction_order_complete'),
    // 保存
    saveImages: ajax.create('/auctions', {
      useJsonData: true
    }),
    // 获取车辆信息
    getBasicInfo: ajax.query('/auctions'),
    // 获取指定车型详细参数
    getAppointedCarInfo: ajax.query('/auctions/car_models'),
    // 保存车辆基本信息
    saveBasicInfo: ajax.create('/auctions', {
      useJsonData: true
    }),
    // 获取车辆配置信息
    getConfigInfo: ajax.query('/auctions'),
    // 保存车辆配置信息
    saveConfigInfo: ajax.create('/auctions', {
      useJsonData: true
    }),
    // 获取手续信息
    getProcedureInfo: ajax.query('/auctions'),
    // 保存车辆手续信息
    saveProcedureInfo: ajax.create('/auctions', {
      useJsonData: true
    }),
    // 获取备注信息
    getRemarkInfo: ajax.query('/auctions'),
    // 保存车辆备注信息
    saveRemarkInfo: ajax.create('/auctions', {
      useJsonData: true
    }),
    // 获取检测信息
    getInspectionsInfo: ajax.query('/auctions'),
    // 保存检测信息
    saveInspectionsInfo: ajax.create('/auctions', {
      useJsonData: true
    }),
    // 获取拍卖场次列表
    getAuctionSessions: ajax.query('/auctions/sessions/query'),
    // 获取之前提交的拍卖信息
    getCommitedAuctionInfo: ajax.query('/auctions/submit_car_auction'),
    // 提交拍卖
    commitAuctionRequest: ajax.create('/auctions/submit_car_auction', { useJsonData: true }),
    // 出价信息
    getOfferInfo: ajax.query('/auctions'),
    // 查看拍卖车辆详情
    getAuctionDetail: ajax.query('/auctions'),
    // 获取车辆拍卖状态(定时轮询最新状态)
    getAuctionDetailStatus: ajax.query('/auctions'),
    // 获取最新拍卖场次列表
    getAuctionSessionsList: ajax.query('/auctions/sessions'),
    // 获取联系人列表
    getContactList: ajax.query('/auctions/submit_car_auction/contacts'),
    // 新增联系人
    addContact: ajax.create('/auctions/submit_car_auction/new_contact', { useJsonData: true }),
    // 编辑联系人
    editContact: ajax.create('/auctions/submit_car_auction/contact', { useJsonData: true }),
    // 删除联系人
    delContact: ajax.delete('/auctions/submit_car_auction/contact'),
    // 判断能否操作联系人
    occupyContact: ajax.query('/auctions/submit_car_auction/contact_in_use')
  },
  match: {
    getMatchList: ajax.query('/auctions/auction_matches'), // 流拍撮合管理列表
    getMatchCarDetail: ajax.query('/auctions/auction_matches/match_car_details'), // 流拍撮合车辆详情
    getMatchDealer: ajax.query('/auctions'), // 撮合车商
    postMatch: ajax.create('/auctions', { useJsonData: true }), // 提交撮合(包含询价撮合和流拍撮合)
    getMatchOrder: ajax.query('/auctions/auction_matches/match_order'), // 流拍撮合订单详情
    postCompleteOrder: ajax.create('/auctions/auction_matches/order_complete'), // 流拍撮合确认收款
    putCloseOrder: ajax.putWay('/auctions/auction_matches/order_close'), // 流拍撮合关闭交易
    getMatchableAuctionsList: ajax.query('/auctions/auction_cars'), // 流拍撮合选择
    getMatchableEnquiriesList: ajax.query('/auctions/auction_cars'), // 询价撮合选择
    getEnquiryList: ajax.query('/auctions/enquiry_matches'), // 询价撮合列表
    getEnquiryOrder: ajax.query('/auctions/enquiry_matches/match_order'), // 流拍撮合订单详情
    putEnquiryCloseOrder: ajax.putWay('/auctions/enquiry_matches/match_order'), // 询价撮合关闭交易
    postEnquiryCompleteOrder: ajax.create('/auctions/enquiry_matches/match_order'), // 询价撮合确认收款
    getEnquiryCarDetail: ajax.query('/auctions/enquiry_matches'), // 询价撮合汽车详情
    getEnquiryMatchConfig: ajax.query('/auctions/auction_car_enquiries/enquiry_config'), // 获取询价场次保证金与佣金
    getAuctionMatchConfig: ajax.query('/auctions/auction_match/auction_config') // 获取流拍场次保证金与佣金
  },
  // 报废、零售、批售出库
  outBound: {
    getMenu: ajax.query('/auctions/outbound/menu'), // 二手车出库菜单
    postScrap: ajax.create('/auctions/scrap', { useJsonData: true }), // 二手车提交报废出库
    postBatchSale: ajax.create('/auctions/batch_sale', { useJsonData: true }), // 二手车提交其他批售出库
    postRetail: ajax.create('/auctions/retail', { useJsonData: true }), // 二手车提交零售出库
    postSpecial: ajax.create('/auctions/special_outbound', { useJsonData: true }), // 二手车提交特殊出库
    getRetailEmployees: ajax.query('/auctions/retail/employees'), // 提交零售-销售人员列表
    getOutBoundCarDetail: ajax.query('/auctions'), // 出库车辆详情
    getManageList: ajax.query('/auctions/outbound_requests'), // 出库管理列表
    reviewOutbound: ajax.create('/auctions/outbound_requests', { useJsonData: true }) // 出库管理列表
  },
  // 车辆二维码
  carQrCode: {
    getToken: ajax.query('/csfr_token'),
    saveQrCodeInfo: ajax.create('/take_over_serve_car')
  },
  // 经营分析数据
  dataAnalysis: {
    getInsuranceData: ajax.query('/dc/insurances/statistic'), // 续保统计
    getCarAuth: ajax.query('/dc/privilege'), // 判断用户是否具有查看集团数据权限
    getCarDaily: ajax.query('/dc/car/visits/statistic/daily'),
    getCarMonthly: ajax.query('/dc/car/visits/statistic/monthly'),
    getFansDaily: ajax.query('/dc/fans/statistic/daily'),
    getFansMonthly: ajax.query('/dc/fans/statistic/monthly'),
    getInsuranceDaily: ajax.query('/dc/insurances/statistic/daily'),
    getInsuranceMonthly: ajax.query('/dc/insurances/statistic/monthly'),
    getInsuranceDailyDetail: ajax.query('/dc/insurances/statistic/daily'),
    getInsuranceMonthDetail: ajax.query('/dc/insurances/statistic'),
    //  到店转成交统计 - 到店客户
    getArriveToDealAnalysis: ajax.query('/sale_report/arrive_to_deal_analysis'),
    // 意向车型转成交统计 - 到店客户
    getIntentionCar: ajax.query('/sale_report/intention_car_statistical_analysis'),
    // 客户区域分布转成交统计 - 到店客户
    getCustomerArea: ajax.query('/sale_report/customer_area_statistical_analysis'),
    // 意向级别 - 到店客户
    getCustomerIntention: ajax.query('/sale_report/customer_intention_statistical_analysis'),
    // 销售指标统计 - 销售顾问
    getSaleQuotaAnalysis: ajax.query('/sale_report/sale_quota_analysis'),
    // 所有的销售顾问
    getSales: ajax.query('/sale_report/sales'),
    // 销售顾问营销漏斗分析 - 销售顾问
    getSaleFunnel: ajax.query('/sale_report/sale_funnel_statistical_analysis'),
    // 跟进概况 - DCC跟进
    getAllClues: ajax.query('/sale_report/all_clues'),
    // 待跟进 - DCC跟进
    getDccClueFollowUp: ajax.query('/sale_report/dcc_clue_follow_up'),
    // 所有的DCC
    getDccs: ajax.query('/sale_report/dccs'),
    // DCC专员营销漏斗分析 - DCC跟进
    getDccFunnel: ajax.query('/sale_report/dcc_funnel_statistical_analysis'),
    // 获取当前所属集团
    getCurrentGroup: ajax.query('/sale_report/current'),
    // 销售展厅指标统计
    getStatistical: ajax.query('/sale_report/store_statistical_analysis'),
    // 潜客到店成交指标统计
    getArriveAnalysis: ajax.query('/sale_report/cule_arrived_statistical_analysis'),
    // 潜客意向车型转成交统计
    getCarseriesAnalysis: ajax.query('/sale_report/car_series_statistical_analysis'),
    // 线索转成交统计
    getClueToDeal: ajax.query('/sale_report/dcc_clue_to_deal_statistical_analysis'),
    // 客户区域分布转成交统计
    getAreaStatistical: ajax.query('/sale_report/dcc_area_statistical_analysis'),
    // 客户信息渠道转成交统计
    getChannelAnalysis: ajax.query('/sale_report/channel_statistical_analysis'),
    // 所有店铺
    getAllStores: ajax.query('/sale_report/stores'),
    // 到店转成交漏斗分析
    getArriveToDeal: ajax.query('/sale_report/arrived_statistical_analysis'),
    // 潜客线索转成交漏斗统计分析
    getClueStatistical: ajax.query('/sale_report/cule_statistical_analysis'),
    // 销售首页
    getStoreSummary: ajax.query('/sale_report/store_summary'),
    // 战败原因TOP5
    getDefeatTop: ajax.query('/sale_report/defeat_top5'),
    // 当前所属集团 / 店铺
    getCurrentAuth: ajax.query('/sale_report/current'),
    // 老友记二手车各渠道线索占比
    getUsedcarData: ajax.query('/used_car')
  },
  // 权限相关
  auth: {
    getAuth: ajax.query('/common/current_user_info'),
    getCustomized: ajax.query('store_config', optionNoneV),
    // 选择/切换门店
    chooseStore: (id: string) => ajax.create(`/change_store/${id}`, {
      customUrl: '/auth'
    }),
    getWeixinUrl: ajax.query('auth/weixin', optionNoneV),
    authLogout: ajax.query('auth/logout', optionNoneV),
    isLogin: ajax.query('auth/is_login', optionNoneV),
    getJwtToken: ajax.create('/exchange_token', {
      customUrl: '/auth'
    })
  },
  // 销售管理
  saleManage: {
    // 获取汽车品牌和车系列表
    getCarBrandList: ajax.query('/jzg_car_models/brands'),
    // 获取车系下的所有车型
    getCarModelList: ajax.query('/jzg_car_models/series'),
    // 获取指定车型详细参数
    getAppointedCarInfo: ajax.query('/jzg-model-detail'),
    // 所有的枚举变量，code与字符串的对应
    getEnums: ajax.query('/sale_potential_customer/enums'),
    // 经理工作台 所有销售
    getSales: ajax.query('/sale_potential_customer/sales'),
    // 经理工作台 待办事项
    getSummary: ajax.query('/sale_potential_customer/pending_approve_summary'),
    // 经理工作台 今日动态,今日战绩
    getCustomersStatistics: ajax.query('/sale_potential_customer/statistics'),
    // 成交确认列表(成交和已签单的客户)
    getSignedAndDeals: ajax.query('/sale_potential_customer/signed_and_deal'),
    // 驳回成交(未成交)
    rejectDeal: ajax.create('/sale_potential_customer/reject_deal', {
      useJsonData: true
    }),
    // 确认成交
    confirmDeal: ajax.create('/sale_potential_customer/confirm_deal', {
      useJsonData: true
    }),
    // 战败审核列表(战败和待审核)
    getFailAndPending: ajax.query('/sale_potential_customer/fail_and_pending_fail'),
    // 审核通过
    examinePass: ajax.create('/sale_potential_customer/confirm_fail', {
      useJsonData: true
    }),
    // 审核不通过
    examineNotPass: ajax.create('/sale_potential_customer/reject_fail', {
      useJsonData: true
    }),
    // 员工工作统计概览
    staffWorkStatistics: ajax.query('/sale_potential_customer/staff_work_summary'),
    // 预约到店-客户
    reservationCustomer: ajax.query('/sale_potential_customer/today_book_customer'),
    // 预约到店-线索
    reservationClue: ajax.query('/sale_potential_customer/today_book_clue'),
    // 添加线索跟进记录
    addClueRecord: ajax.create('/sale_potential_customer/clue_note', {
      useJsonData: true
    }),
    // 到店客流
    todayStoreVisit: ajax.query('/sale_potential_customer/today_store_visit'),
    // 到店客流客户详情
    arrivedCustomerInfo: ajax.query('/sale_potential_customer/customers'),
    // 保存 到店客流客户跟进记录
    customerArriveNote: ajax.create('/sale_potential_customer/customer_arrive_note', {
      useJsonData: true
    }),
    // 保存 客户电话跟进记录
    createCustomerPhoneNote: ajax.create('/sale_potential_customer/create_customer_phone_note', {
      useJsonData: true
    }),
    // 线索档案详情
    clueArchivesDetail: ajax.query('/sale_potential_customer/clue'),
    // 线索提交/ 创建线索
    createClue: ajax.create('/sale_potential_customer/clue', {
      useJsonData: true
    }),
    // 更新线索
    updateClue: ajax.patch('/sale_potential_customer/clue', {
      useJsonData: true
    }),
    // 确定联系
    clueConfirmContacted: ajax.create('/sale_potential_customer/contact_clue', {
      useJsonData: true
    }),
    // 确定预约
    clueConfirmAppointed: ajax.create('/sale_potential_customer/booking_clue', {
      useJsonData: true
    }),
    // 取消预约
    cancelBookClue: ajax.create('/sale_potential_customer/cancel_book_clue', {
      useJsonData: true
    }),
    // 创建客户
    createCustomer: ajax.create('/sale_potential_customer/customer', {
      useJsonData: true
    }),
    // 更新客户
    updateCustomer: ajax.patch('/sale_potential_customer/customer', {
      useJsonData: true
    }),
    // 确认签单
    sureSignTheBill: ajax.create('/sale_potential_customer/sign_customer', {
      useJsonData: true
    }),
    // 申请战败
    applyFail: ajax.create('/sale_potential_customer/apply_fail', {
      useJsonData: true
    }),
    // 今日线索任务
    todayClueTask: ajax.query('/sale_potential_customer/today_clue_tasks'),
    // 全部线索任务
    clueTask: ajax.query('/sale_potential_customer/clue_tasks'),
    // 全部线索
    allClues: ajax.query('/sale_potential_customer/clues'),
    // 手机号查找客户
    getCustomerInfoByMobile: ajax.query('/sale_potential_customer/search_customer_by_mobile'),
    // 关联客户
    associateCustomer: ajax.create('/sale_potential_customer/bind_store_visit_to_customer', {
      useJsonData: true
    }),
    // 今日客户任务(任务)/全部客户任务 列表
    todayCustomerTaskTask: ajax.query('/sale_potential_customer/customer_tasks'),
    // 今日客户任务(客户)
    todayCustomerTaskCustomer: ajax.query('/sale_potential_customer/today_pending_contact_customer'),
    // 全部客户
    getAllCustomers: ajax.query('/sale_potential_customer/customers'),
    // 客户统计
    customerStatistics: ajax.query('/sale_potential_customer/customer_statistics'),
    // // 意向车型 TODO: 检查是否涉及精友
    // intendBrands: ajax.query('/car_models/brands')
    intendBrands: ajax.query('/sale_potential_customer/store_brands')
  },
  // 保险模块
  insurance: {
    quote: {
      // 报价信息
      info: ajax.query('/quote'),
      // 新报价信息
      infoFromGateway: ajax.query('/quote/gateway')
    },
    updateInfo: {
      // 获取系统数据和保司数据不同点
      getDiff: ajax.query('/quote_renewal/diff'),
      // 确定更新
      update: ajax.query('/quote_renewal/update')
    }
  },
  // 离店登记模块
  leaveStore: {
    // 获取离店信息
    getCarVisitInfo: ajax.query(`/car_visit/checkout`),
    // 离店登记
    postCarVisitRegister: ajax.create('/car_visit/checkout', { useJsonData: true })
  },
  // 到店登记模块
  carRegister: {
    // 获取该店的车间名称
    getWorkshops: ajax.query('/car_visit/workshops'),
    // 车辆到店登记
    postRegister: ajax.create('/car_visit/register', {
      useJsonData: true
    }),
    // 进车间车辆登记
    postWorkShopRegister: ajax.create('/car_visit/register/workshop_visit', {
      useJsonData: true
    }),
    // 获取客户信息
    getCustomerInfo: (customerId:number) => ajax.query(`/sales_receptions/customer/${customerId}`),
    // 通过车牌号获取客户信息
    getCustomerInfoWithPlateNumber: ajax.query(`/sales_receptions/customer/with_plate_number`),
    // 获取客户笔记记录
    getNotes: (customerId:number) => ajax.query(`/sales_receptions/${customerId}/notes`),
    // 获取销售笔记列表 /sales_receptions/customers 待替换老接口: /track_customer/list_records
    getSalesNoteList: ajax.query('/sales_receptions/customers'),
    // 新增客户
    addSalesCustomer: ajax.create('/sales_receptions/customer', {
      useJsonData: true
    }),
    // 编辑客户
    editSalesCustomer: (customerId:number) => ajax.patch(`/sales_receptions/customer/${customerId}`, {
      useJsonData: true
    }),
    // 获取销售接待设置
    getSaleConfig: ajax.query('/sales_receptions/configs'),
    // 新增客户笔记
    addSaleNote: (customerId:number) => ajax.create(`/sales_receptions/${customerId}/note`, {
      useJsonData: true
    }),
    // 补充客户笔记
    editSaleNote: (noteId:number) => ajax.patch(`/sales_receptions/note/${noteId}`, {
      useJsonData: true
    }),
    // 客户下挂车辆更新
    tansferCar: ajax.create('/sales_receptions/customer/transfer_car', {
      useJsonData: true
    })
  },
  reviews: {
    getReviewsList: ajax.query('/auctions/reviews'),
    getReviewsDetail: ajax.query('/auctions/review/dealer_user'),
    createReview: ajax.create('/auctions/review/car_shop', { useJsonData: true })
  },
  // 过户管理模块
  transfer: {
    getTransfers: ajax.query('/auctions/car_transfers'), // 过户管理
    getTransferData: ajax.query('/auctions/car_transfer/detail'), // 过户资料
    unfreezeDeposit: ajax.create('/auctions/car_transfer/unfreeze', { useJsonData: true }), // 解冻保证金
    confirmTransfer: ajax.create('/auctions/car_transfer', { useJsonData: true }), // 确认过户
    downloadTransferData: ajax.query('/auctions/document') // 下载过户资料图片
  },
  // 排行榜
  rank: {
    getTotalRankList: ajax.query('/used_car/total_leaderboard'),
    getPersonalRankList: (type: string) => ajax.query(`/used_car/personal_leaderboards/${type}`),
    getStoreRankList: (type: string) => ajax.query(`/used_car/store_leaderboards/${type}`)
  },
  clue: {
    getClueList: ajax.query('/sale_potential_customer/car_purchase_clues'),
    modifyName: (customerId: number) => ajax.create(`/sale_potential_customer/customer/real_name/${customerId}`, { useJsonData: true })
  },
  // 线上取号
  tool: {
    getMealNumbers: ajax.query('/meal/numbers'),
    getMealNotice: ajax.create('/meal/notice', { useJsonData: true }),
    getMealDined: ajax.create('/meal/dined', { useJsonData: true })
  },
  // 市场营销
  marketing: {
    /** 集客报名活动相关 */
    // 获取活动列表
    getActivityList: ajax.query('/attraction/activities'),
    // 获取活动排名列表
    getActivityRankList: ajax.query('/attraction/statistics'),
    // 获取用户访问记录
    getUserViewRecords: ajax.query('/attraction/statistics/user_view_records'),
    // 获取个人活动排名
    getSelfActivityRank: ajax.query('/attraction/statistic'),
    // 生成个人分享链接
    createShareUrl: ajax.create('/attraction/statistics', { useJsonData: true }),
    /** 转介绍相关 */
    getInvitationConfig: ajax.query('/marketing/invitation/config')
  }
}

type AutoInfer < T > = {
  readonly[K in keyof T]: T[K]
}
export type Api = AutoInfer < typeof rest >

export default rest as Api
